<template>
  <div class="operator">
    <div class="operator-inputs">
      <primary-select v-if="rateType !== 'prefix'"
                      type="text"
                      name="country"
                      class="country-select"
                      :value="operator.code"
                      @input="handleCodeChange"
                      placeholder="Enter country" 
                      :options="country_list"/>
      <primary-select v-if="rateType !== 'prefix'"
                      type="text"
                      name="operator"
                      class="rate-select"
                      :value="operator.mobile_network_uuid"
                      @input="handleMobileNetworkChange"
                      :options="networks"
                      placeholder="Enter country"/>
      <primary-input v-if="rateType === 'prefix'" 
                     type="text"
                     name="code"
                     class="code-input"
                     :value="operator.code" 
                     @input="handleCodeChange" 
                     :class="{'input': true, 'is-danger': errors.has('code')}"                  
                     placeholder="Enter code"/>
      <div class="help is-danger" v-if="errors.has('code')"> {{ errors.first('code') }}</div>
      <primary-input type="text"
                     name="sell rate"
                     class="company-select"
                     :value="operator.price"
                     @input="handlePriceChange"
                     placeholder="Enter sell rate"/>
    </div>
    <div class="close-button" @click.stop="() => deleteOperator(index)">
      <svg class="icon"
           width="30px"
           height="30px"
           viewBox="0 0 30 30"
           version="1.1">
        <path transform="translate(14.977556, 14.977594) rotate(45.000000) translate(-14.977556, -14.977594) "
              d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
              id="path-1">
        </path>
      </svg>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex';
import getDataForProduct from '../mixins/getDataForProduct';

export default {
  name: 'AddProductOperator',
  components: {
    PrimaryInput: () => import('@/components/Inputs/PrimaryInput.vue'),
    PrimarySelect: () => import('@/components/Inputs/PrimarySelect.vue'),
  },
  props: ['country_list','index', 'operatorProp', 'rateType', 'vendorsLength', 'vendorsList', 'fromIndex'],
  mixins: [getDataForProduct],
  computed: {
    ...mapGetters({
      activeOperatorId: 'rateTable/getActiveRateId',
      allMobiileNetworks: 'products/getAllMObileNetworks',
      mobileNetworksTotal: 'mobileNetwork/getTotal',
      routing: 'routing/getRouting',

      //operators: 'products/getOperators',
      mobileNetworks: 'mobileNetwork/getMobileNetworkList',
      // testList: 'routing/getActiveVendors', 
    }),
    networks() {
      // let data = this.index === this.activeOperatorId ? this.mobileNetworks : this.allMobiileNetworks[this.index];
      let data = this.allMobiileNetworks[this.index];

      return data ? data.map(item => ({ name: item.network_name, value: item.mobile_network_uuid })) : [];
    },
    operator() {
      return this.operatorProp;
    }
  },
  created() {
    //console.log("testList 0000 ->", this.testList);
  },
  methods: {
    ...mapActions({
      removeRate: 'rateTable/removeRate',
      updateOperator: 'rateTable/updateRate',
      chageActiveOperatorId: 'rateTable/updateActiveRateId',
      addMobileNetworkList: 'products/addMobileNetworkList',
      removeMovileNetworkList: 'products/removeMovileNetworkList',
      viewMobileNetworks: 'mobileNetwork/GetMobileNetworks',
      addRoute: 'routing/addRoute',

      updateNetworkName: 'products/updateNetworkName',
      viewMobileNetwork: 'mobileNetwork/GetMobileNetwork',
      removeVendor: 'routing/removeRoute',

      updateVendor: 'routing/updateRoute',
      removeVendor: 'routing/removeRoute',
    }),
    async handleCodeChange(code) {      
      if(this.rateType === 'prefix') {
        for(let i = 0; i < this.routing.routes.length; i++) {
          if(this.routing.routes[i].code === this.operator.code) {
              this.removeVendor(i);
              i = 0;
            }
        }
      }
      this.updateOperator({ code });

      let route = {};

      if(this.rateType === 'prefix' && code ) { // && this.testList.length === 0
        route.code = code;

        this.addRoute(route);
        
        this.getRateList( {code }, this.rateType);
        return
      } else {
        // this.updateVendor({ fields: { code }, index: this.fromIndex });
      }
      
      await this.viewMobileNetworks({ country_code: code });
      await this.viewMobileNetworks({ per_page: this.mobileNetworksTotal, country_code: code });

      this.addMobileNetworkList({ mobileNetworkList: this.mobileNetworks, index: this.activeOperatorId});
    }, 
    handleMobileNetworkChange(mobile_network_uuid) {
      this.viewMobileNetwork(mobile_network_uuid);

      for(let i = 0; i < this.routing.routes.length; i++) {
        if(this.routing.routes[i].mobile_network_uuid === this.operator.mobile_network_uuid) {
            this.removeVendor(i);
            i = 0;
          }
      }

      this.updateOperator({ mobile_network_uuid });

      //if(this.vendorsLength === 0) {
        let route = {};
        route.mobile_network_uuid = mobile_network_uuid;

        this.addRoute(route);
      //}
      
      this.getRateList({ mobile_network_uuid }, this.rateType);
    },
    handlePriceChange(price){
      this.updateOperator({ price: price.toString() });
    },
    deleteOperator(index) {
      if(this.rateType === 'prefix') {
        for(let i = 0; i < this.routing.routes.length; i++) {
          if(this.routing.routes[i].code === this.operator.code) {
              this.removeVendor(i);
              i = 0;
            }
        }
      } else if(this.rateType === 'MNCMCC') {
        for(let i = 0; i < this.routing.routes.length; i++) {
          if(this.routing.routes[i].mobile_network_uuid === this.operator.mobile_network_uuid) {
              this.removeVendor(i);
              i = 0;
            }
        }
      }
      this.removeRate(index);

      // need to check operators length in right why
      // if(index > this.activeOperatorId || this.operators.length === 0) { return }

      this.removeMovileNetworkList(index);

      if(this.index === 0 && this.activeOperatorId === 0) {
        this.chageActiveOperatorId(index);
      } if(this.index === 0 && this.activeOperatorId !== 0) {
        this.chageActiveOperatorId(this.activeOperatorId - 1);
      } else {
        this.chageActiveOperatorId(index - 1);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.operator {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px 0 0 15px;
  margin-bottom: 10px;
  .operator-inputs {
    width: calc(100% - 55px);
    justify-content: space-between;
    display: flex;
    margin-bottom: 20px;
    .country-select {
      width: 26%;
    }
    .rate-select {
      width: 37%;
    }
    .company-select {
      width: 31%;
    }
    .code-input {
      width: 66%;
    }
  }
  .close-button {
    cursor: pointer;
    fill: #55616e;
    height: 30px;
    margin-right: 12.5px;
    margin-left: 12.5px;
    width: 30px;
    margin-top: 25.5px;
  }
}
</style>

